<template>
  <div v-for="(L2DataPoint, index) in filteredItems" :key="L2DataPoint.label" class="comparison-table-row">
    <!-- Mobile -->
    <CarComparisonMobileDataTable v-if="isMobile" :cars-to-compare="carsToCompare" :data-point="L2DataPoint" :get-data-value="getDataValue" />

    <!-- Tablet & Desktop -->
    <div v-else class="comparison-grid__container">
      <CarComparisonDesktopDataTable
        v-for="(carData, carIndex) in carsToCompare"
        :key="`car__${carIndex}`"
        :data-point="L2DataPoint"
        :index="index"
        :car-data="carData"
        :get-data-value="getDataValue"
        :class="[`car-${carIndex}`]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { transformDataPoint } from '../../foundation/carDataFieldTransforms';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';
import CarComparisonDesktopDataTable from './CarComparisonDesktopDataTable.vue';
import CarComparisonMobileDataTable from './CarComparisonMobileDataTable.vue';
import { storeToRefs } from 'pinia';

const props = defineProps<{
  filteredItems: any;
  carsToCompare: any;
  isMobile: boolean;
}>();

const comparisonStore = useCarComparisonStore();
const { fetchedVehicles } = storeToRefs(comparisonStore);

type DataValueTypes = {
  carData: any;
  dataPoint: any;
};

function getDataValue({ carData, dataPoint }: DataValueTypes): string | undefined {
  if (dataPoint.amsField?.value && carData?.Vehicle_UID) {
    const vehicleData = fetchedVehicles.value[carData.Vehicle_UID];
    // Data from API is a string separated by a pipe in order accommodate multiple values
    const vehicleDataKeys = dataPoint.amsField?.value.split('|');
    // The name of the transform function to execute
    const vehicleDataTransformFunctions = dataPoint.selectedDataTransforms.targetItems.map((item: any) => ({ functionName: item.function.value }));

    if (vehicleDataKeys.length > 0) {
      // If we have a transform, then process it and pass in one or more data keys (fields)
      if (vehicleDataTransformFunctions.length > 0) {
        return transformDataPoint(vehicleData, vehicleDataKeys, vehicleDataTransformFunctions);
      }

      // Otherwise just return the field data for a single field, with no transform
      return vehicleData[vehicleDataKeys[0]] ?? 'N/A';
    }

    return 'No data key provided.';
  }

  return undefined;
}
</script>

<style lang="scss" scoped>
.comparison-table-row {
  margin-bottom: 0;

  &:last-of-type {
    margin-bottom: 0.5rem;
  }
}
</style>
